

<template>
  <div :style="divStyle">
    <slot name="progress" v-if="value === 'running'"></slot>
    <slot name="quiet" v-if="value === 'done' || value === 'none'"></slot>
    <slot name="done" v-if="value === 'done'"></slot>
    <slot name="error" v-if="value === 'error'"></slot>
  </div>
</template>

<script>
import { jobs } from "../api/jobs.js";

export default {
  name: "JobProgress",
  props: {
    job_id: Number,
    value: String,
    divStyle: {
      type: String,
      default: "",
    }
  },
  data() {
    return {
      interval: null,
    };
  },
  watch: {
    value: function (val) {
      if (val === "running" && !this.interval && this.job_id) {
        this.interval = setInterval(this.fetchJobState, 2000);
      }
    },
  },
  methods: {
    async fetchJobState() {
      try {
        const response = await jobs.getJob({ id: this.job_id });
        const downloadJobState = response.data.state;
        if (downloadJobState === "done") {
          clearInterval(this.interval);
          this.interval = null;
          this.$emit("done");
          this.$emit("input", "done");
        } else if (downloadJobState === "error") {
          clearInterval(this.interval);
          this.interval = null;
          this.$emit("error");
          this.$emit("input", "error");
        }
      } catch (error) {
        console.debug(error);
      }
    },
  },
};
</script>

